// extracted by mini-css-extract-plugin
export default {"menuBlock":"oG-z","title":"pG-z","nav":"qG-z","flexCell":"rG-z","facetLink":"sG-z"};